export const CODE_THEMES = ['default', 'cobalt', 'dracula', 'eclipse', 'material-darker', 'neat', 'neo'] as const
